// Include JR Starter core files


// General
//@codekit-prepend "general/helpers.js"
//@codekit-prepend "general/modernizr.js"
//@codekit-prepend "general/picturefill.js"
//@codekit-prepend "general/jquery.unevent.js"
//@codekit-prepend "general/magnific-popup.js"
//@codekit-prepend "general/doubleTapToGo.js"

//
// Foundation
//@codekit-prepend "jr-foundation-min.js"


// JR Plugins
//@codekit-append "jr-plugins/load-images.js"
//@codekit-append "jr-plugins/scroll-animate.js"
//@codekit-append "jr-plugins/banner.js"
//@codekit-append "jr-plugins/fix-this.js"


// Templates
// @codekit-append "templates/header.js"


// Classes
// @codekit-append "classes/menu.js"



(function ( $ ) {
	
	"use strict";
	
	$(document).ready(onReady);
	$(window).on('load', onLoad);
	
	// Callback function for when the page is ready
	function onReady() {
		
		// Initialise Foundation
		$(document).foundation();

		// FontAwesome Items
		$('ul.fa-ul').each( function() {
			var $this = $(this);
			var icon = $this.data('icon');
			$this.children('li').prepend('<span class="fa-li"><i class="' + icon + '"></i></span>');
		});

		// Allow menu dropdowns to show on touch devices
		$( 'nav li.menu-item-has-children' ).doubleTapToGo();


		// Slick
		$('.jr-carousel [data-slick]').slick();

		// DZS Parallax
		/* dzsprx_init('.dzsparallaxer', { 
			direction: "reverse", 
			mode_scroll:"normal",
			animation_duration: 5,
			is_fullscreen: true
		} ); */


		// Magnific Popup - Gallery
		$('[data-mfp-popup]').each( function() {

			var $this = $(this);
			var target = $this.data('mfp-popup');
			var type = $this.data('mfp-type');
			var href = $this.attr('href');
			var animation = $this.data('mfp-animation');

			

			if ( typeof target === 'undefined' || target === null || target === '' || target === 1 ) {
				target = href;
			}

			if ( typeof type === 'undefined' ) {
				type = 'inline';
			}

			if ( typeof animation === 'undefined' ) {
				animation = 'fade';
			}

			if ( type === 'gallery' ) {

				$this.magnificPopup({
					delegate: 'a',
					type: 'image',
					tLoading: 'Loading image #%curr%...',
					mainClass: 'mfp-' + animation,
					removalDelay: 300,
					gallery: {
						enabled: true,
						navigateByImgClick: true,
						preload: [0,1] // Will preload 0 - before current, and 1 after the current image
					},
					image: {
						tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
						titleSrc: function(item) {
							return item.el.attr('title');
						}
					}
				});

			} else if ( type === 'iframe' ) { 

				// Magnific Popup - Iframe
				$this.magnificPopup({
					disableOn: 700,
					type: 'iframe',
					mainClass: 'mfp-' + animation,
					removalDelay: 300,
					preloader: false,
					fixedContentPos: false,
					items: {
						src: target
					}
				});

			} else if ( type === 'inline' ) {
				
				// Magnific Popup - Inline
				// <a class="popup-inline" href="#popup-id">Open Popup</a>
				// <div id="popup-id" class="mfp-hide mfp-popup">
				$this.magnificPopup({
					type: 'inline',
					preloader: false,
					mainClass: 'mfp-' + animation,
					removalDelay: 300,
					focus: '.initial-focus',
					items: {
						src: target
					},
			
					// When elemened is focused, some mobile browsers in some cases zoom in
					// It looks not nice, so we disable it:
					callbacks: {
						beforeOpen: function() {

							if($(window).width() < 700) {
								this.st.focus = false;
							} else {
								this.st.focus = '.initial-focus';
							}

						}
						/*
						open: function() {
							var video = document.getElementById('promo-video-el');

							if () {

							}

							video.play();

							video.addEventListener('ended', (e) => {
								this.close();
							}, false);

							$('#promo-video-el').toggle( function() {
								video.pause();
							}, function() {
								video.play();
							});
						},
						close: function() {

							var video = document.getElementById('promo-video-el');
							video.pause();
							
						}
						*/
					}
				});

			}

		});

		// Close Popup
		$('body').on('click', '.mfp-close-popup', function() {
			$.magnificPopup.close();
		});
		

		


		


		

		// MMenu
		var smallMenu = $('#jr-small-menu');
		if (
			$.isFunction($.fn.mmenu) &&
			smallMenu.length === 1
		) {

			var type = smallMenu.data('type');

			var options = {
		        extensions: [
		        "fx-menu-slide",
		        "pagedim-black"
		        ]
		    };

		    var configurations = {

		        offCanvas: {
		            pageSelector: "#page"
		        },

		        classNames: {
		            fixedElements: {
		               fixed: "jr-small-top-menu"
		            }
		        }
		    }

		    if (type === 'popup') {

		    	options.extensions.push("popup");
		    	var index = options.extensions.indexOf('fx-menu-slide');
		    	if (index > -1) {
				    options.extensions.splice(index, 1);
				}

		    }

			$("#jr-small-menu").mmenu(options, configurations);

		}


	}
	
	function onLoad() {
		



		
	}


	// Submit info to Google Analytics
	$( document ).on( "jrpForm:Submit", function( event, $form, submission ) {

		// Dont track if not gtag theme enabled
		if ( ! $('body').hasClass('theme-gtag') ) {
			return;
		}

		if ( submission.type !== 'valid' ) {
			return;
		}
		
		var formName = submission.form_name;

		// Prevent the browser from submitting the form
		// and thus unloading the current page.

		gtag('event', 'submit', {
			'event_category': 'Forms',
			'event_label': formName,
			'event_callback': function() {

			}
		});

	});

}( jQuery ));
